import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageCenter'
})
export class ImageCenterPipe implements PipeTransform {


  transform(img: HTMLImageElement, quantity: number): number {

    const calculateRatio = (firstNum: number, secondNum: number) => {

      let num = 0;

      for (num = secondNum; num > 1; num--) {
        if ((firstNum % num) === 0 && (secondNum % num) === 0) {
          firstNum = firstNum / num;
          secondNum = secondNum / num;
        }
      }
      return firstNum / secondNum;
    };

    const RATIO = calculateRatio(img.height, img.naturalHeight);

    const VAL = ((img.naturalWidth * RATIO) % window.innerWidth) / quantity;

    if (VAL > 0) {
      return VAL;
    } else {
      setTimeout(() => {
        this.transform(img, quantity);
      }, 200);
    };
  }


}
